import {IRestService} from "./IRestService";
import axios, {AxiosPromise} from 'axios';
import {AxiosCall} from "./AxiosCall";

export class AxiosRestService implements IRestService {
	public get<T>(path: string): Promise<T> {
		const url = AxiosRestService.formatUrl(path);

		return AxiosRestService.convertResult(() => axios.get(url));
	}

	public post<TBody, TResult>(path: string, body?: TBody, headers?: any): Promise<TResult> {
		return AxiosRestService.invoke(axios.post, path, body, headers);
	}

	public put<TBody, TResult>(path: string, body?: TBody, headers?: any): Promise<TResult> {
		return AxiosRestService.invoke(axios.put, path, body, headers);
	}

	public delete<TBody, TResult>(path: string, body?: TBody, headers?: any): Promise<TResult> {
		return AxiosRestService.invoke(axios.delete, path, {data: {body}}, headers);
	}

	private static invoke<TBody, TResult>(method: AxiosCall<TResult>, path: string, body?: TBody, headers?: any): Promise<TResult> {
		const url = AxiosRestService.formatUrl(path);

		let headersObject: any = {};
		if (headers) {
			headersObject.headers = headers;
		}

		return AxiosRestService.convertResult(() => method(url, body, headersObject));
	}

	private static formatUrl(path: string): string {
		return `${process.env.REACT_APP_API_URL}${path}`;
	}

	private static convertResult<T>(promiseFactory: () => AxiosPromise<T>): Promise<T> {
		return new Promise<T>((resolve, reject) => {
			const promise = promiseFactory();

			promise
				.then(result => {
					const statusCode = result.status;
					const data = result.data;

					if (statusCode >= 200 && statusCode < 300) {
						resolve(data);
					} else {
						reject(result.statusText || data || statusCode);
					}
				})
				.catch(reason => reject(reason));
		})
	}
}
